import { createSlice } from "@reduxjs/toolkit";

const initialUserData = JSON.parse(localStorage.getItem("myUserData"));
const initialState = initialUserData ? initialUserData : null;

const userSlice = createSlice({
  name: "user",
  initialState: initialState,

  reducers: {
    addUser: (state, action) => {
      const addUserData = action.payload;

      localStorage.setItem("myUserData", JSON.stringify(addUserData));
      return addUserData;
    },
    removeUser: (state, action) => {
      console.log("Removing user and clearing localStorage");
      // Clear localStorage or any other state as needed
      if ("caches" in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      }
      localStorage.clear();

      // Force reload without using cache
      // window.location.reload(true); // Passing 'true' forces a hard reload
      //commented as everything related to user is to be removed from localStorage
      // localStorage.removeItem("myUserData");
      // localStorage.removeItem("myUserCompanyAccessData");
      // localStorage.removeItem("ownerInfo");
      // localStorage.clear();
      // Object.keys(localStorage).forEach((key) => {
      //   if (key.includes("columnFilters")) {
      //     localStorage.removeItem(key);
      //   }
      // });

      return null;
    },
    updateUser: (state, action) => {
      const addUserData = action.payload;
      localStorage.setItem("myUserData", JSON.stringify(addUserData));
      return addUserData;
    },
    addParticularCompany: (state, action) => {
      const addCompanyData = action.payload;
      localStorage.setItem("company_data", JSON.stringify(addCompanyData));
      return { ...state, ...addCompanyData };
    },
    addNotesData: (state, action) => {
      const addCompanyData = action.payload;

      localStorage.setItem("notes_data", JSON.stringify(addCompanyData));
      return { ...state, ...addCompanyData };
    },
    getUserTokeData: (state, action) => {
      const addCompanyData = action.payload;
      const getuserToken = JSON.parse(localStorage.getItem("myUserData"));
      const userToken = getuserToken ? getuserToken : null;
      return { ...state, token: userToken.token };
    },
    addUserCompanyAccess: (state, action) => {
      const addUserCompanyAccessData = action.payload;
      localStorage.setItem("myUserCompanyAccessData", JSON.stringify(addUserCompanyAccessData));
      return { ...state, userCompanyPermissions: addUserCompanyAccessData.permissions };
    },
    getUserCompanyAccess: (state, action) => {
      const addCompanyData = action.payload;
      const getUserCompanyAccessData = JSON.parse(localStorage.getItem("myUserCompanyAccessData"));
      const userCompanyAccessData = getUserCompanyAccessData ? getUserCompanyAccessData : null;
      return { ...state, userCompanyPermissions: userCompanyAccessData?.permissions };
    },
  },
});

export const {
  addUser,
  removeUser,
  resetUserData,
  updateUser,
  addParticularCompany,
  getParticularCompany,
  addNotesData,
  getUserTokeData,
  addUserCompanyAccess,
  getUserCompanyAccess,
} = userSlice.actions;

export default userSlice.reducer;
